/* Shared Shopify market context. Product amounts come from Shopify, never FX estimates. */
(() => {
  const config = window.MiraiMarketConfig;
  if (!config) return;
  const root = config.root.replace(/\/?$/, '/');
  const dictionary = window.MiraiTranslations || {};
  const t = (source, values = {}) => (dictionary[source] || source).replace(/\{(\w+)\}/g, (_, key) => String(values[key] ?? `{${key}}`));
  const formatter = new Intl.NumberFormat(config.locale, {style:'currency', currency:config.currency});
  const money = cents => formatter.format(Number(cents) / 100);
  const rate = () => config.currency === config.shopCurrency ? 1 : Number(window.Shopify?.currency?.rate);
  const convert = cents => { const fx = rate(); return Number.isFinite(fx) && fx > 0 ? Math.round(cents * fx) : null; };
  const url = path => {
    if (/^(?:https?:)?\/\//i.test(path)) return path;
    let result = path.startsWith(root) ? path : root + path.replace(/^\//, '');
    return result.replace(/([?&]return_to=)([^&]*)/, (_,prefix,value) => prefix + encodeURIComponent(url(decodeURIComponent(value))));
  };
  const cache = new Map();
  async function product(handle) {
    if (!/^[a-z0-9][a-z0-9-]*$/i.test(handle)) throw Error('Invalid product');
    if (!cache.has(handle)) cache.set(handle, fetch(url('products/' + encodeURIComponent(handle) + '.js')).then(r => {if (!r.ok) throw Error('Unavailable product'); return r.json();}));
    return cache.get(handle);
  }
  window.MiraiMarket = { ...config, root, t, money, convert, url, product };
})();
